import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=79a8a97a&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=79a8a97a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a8a97a",
  null
  
)

export default component.exports